module.exports = __webpack_public_path__ + "img/treatments-directory-card-mobile-en.e7e321af.jpg";